module.exports = __webpack_public_path__ + "img/174.4dc3244f.jpg";